export default {"src":"/_next/static/media/gradio.4e207dfb.svg","height":800,"width":900};